import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { DayOfWeek, Geofence, GeofenceRule, User } from '../../../../core/models/organization.interface';
import { GeofenceService } from '../../../../core/services/geofence.service';
import * as Cesium from 'cesium';
import { CoresService } from '../../../../core/services/cores.service';
import { CameraService } from '../../../../core/services/camera.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseModalComponent } from '../../response-modal/response-modal.component';
import { ApiService } from '../../../../core/services/api.service';
import { OrganizationUtilService } from '../../../../core/services/organization-util.service';
import { ConfigurationManagerService } from '../../../../core/services/configuration-manager.service';
import { IllumPolygonCreatorService } from '../../../../core/services/Illum-polygon-creator.service';
@Component({
  selector: 'app-geofences-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './geofences-list.component.html',
  styleUrl: './geofences-list.component.css'
})
export class GeofencesListComponent implements OnInit, OnChanges {
  @ViewChild('searchInput') searchInput!: ElementRef;
  @Input() geofences: Geofence[] = [];
  @Input() users: User[] = [];
  daysOfWeek: DayOfWeek[] = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  @Input() drawnPolygon: number[][] | null = null;
  @Output() openGeofenceCreator = new EventEmitter<void>();
  rules: GeofenceRule[] = [];
  filteredGeofences: Geofence[] = [];
  searchQuery = '';
  newGeofenceLabel = '';
  showRuleForm = false;
  formMode: 'new' | 'edit' = 'new';
  selectedRule: GeofenceRule | null = null;
  showCreateRuleForm = false;
  // Rule form data
  ruleForm = {
    name: '',
    ingress: false,
    egress: false,
    daysOfWeek: {
      sun: false,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false
    } as Record<DayOfWeek, boolean>,
    startTime: '',
    endTime: '',
    organizationIds: [] as string[],
    userIds: [] as string[],
    geofenceIds: [] as string[],
    perimeterIds: [] as string[],
    active: false,
    openSelectOrganizations: false,
    openSelectUsers: false,
    openSelectGeofences: false,
    openSelectPerimeters: false,
  };

  private searchSubject = new Subject<string>();
  private geofenceDataSource: Record<string, any> = {};
  private integrationPulseUrl = ConfigurationManagerService.settings.integrationPulse;
  viewer: any;
  organizations: any[] = [];
  selectedOrgs: Record<string, boolean> = {};
  allOrgSelected = false;

  userSearchText = '';
  filteredUsers: any[] = [];
  selectedUsers: any[] = [];
  allUsers: any[] = [];

  geofenceSearchText = '';
  filteredSelectableGeofences: Geofence[] = [];
  selectedGeofences: Geofence[] = [];
  buildings: any[] = [];
  floors: any[] = [];
  rooms: any[] = [];
  selectedBuilding: any = null;
  selectedFloor: any = null;
  selectedRoom: any = null;
  filteredPerimeter: any = null;
  selectedPerimeters: any[] = [];
  perimeterRules: any[] = [];

  constructor(
    private api: ApiService,
    private geofenceService: GeofenceService,
    private coresService: CoresService,
    private camera: CameraService,
    private modalService: NgbModal,
    private orgUtil: OrganizationUtilService,
    private illumPolygonCreator: IllumPolygonCreatorService,
  ) {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(query => {
      this.filterGeofences(query);
    });
  }

  ngOnInit(): void {
    this.viewer = this.coresService.getViewer();
    if (this.geofences && this.geofences.length > 0) {
      this.filteredGeofences = [...this.geofences];
    } else {
      this.loadGeofences();
    }
    this.organizations = Object.values(this.orgUtil.myOrgs).sort((a: any, b: any) =>
      (a.name || '').localeCompare(b.name || '')
    );
    this.filteredUsers = this.users;
    this.loadRules();

    this.allUsers = this.users;
    this.filteredSelectableGeofences = this.filterGeofences('');
    this.buildings = this.orgUtil.data.myBuildings;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users'] && changes['users'].currentValue) {
      this.allUsers = changes['users'].currentValue;
      this.userSearchTextChanged();
      this.syncSelectedUsersFromIds();
    }
    this.filteredSelectableGeofences = this.filterGeofences(this.geofenceSearchText);
    this.syncSelectedGeofencesFromIds();
  }
  loadGeofences(): void {
    this.geofenceService.getGeofences().subscribe(
      (geofences: Geofence[]) => {
        this.geofences = geofences;
        this.filteredGeofences = geofences;
      }
    );
  }

  loadRules(): void {
    this.geofenceService.getPerimeterRules().subscribe({
      next: (results) => {
        const rules = (results || []).sort(
          (a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        this.rules = rules;
        this.perimeterRules = rules.map((o: any) => ({
          ...o,
          localTime: new Date(o.createdAt).toLocaleString()
        }));
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  onSearch(event: Event): void {
    const query = (event.target as HTMLInputElement).value;
    this.searchSubject.next(query);
  }

  deleteGeofence(geo: Geofence): void {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    const component = modalRef.componentInstance as ResponseModalComponent;
    component.message = `Delete geofence ${geo.label}?`;
    component.showCancel = true;

    modalRef.result
      .then((confirmed: boolean) => {
        if (confirmed) {
          this.geofenceService.deleteGeofence(geo.id).subscribe({
            next: () => {
              this.removeGeometry(geo);
              this.loadGeofences();
            },
            error: (error) => {
              console.error(error);
            }
          });
        }
      })
      .catch(() => {
      });
  }
  selectAllOrgs(): void {
    this.selectedOrgs = {};
    for (const org of this.organizations) {
      this.selectedOrgs[org.arcAngelId || org.id] = true;
    }
  }

  unselectAllOrgs(): void {
    this.selectedOrgs = {};
  }

  allOrgSelectedChanged(): void {
    if (this.allOrgSelected) {
      this.selectAllOrgs();
    } else {
      this.unselectAllOrgs();
    }
  }

  getNumberOfSelectedOrgs(): number {
    return Object.values(this.selectedOrgs).filter(Boolean).length;
  }

  orgSelected(): void {
    this.ruleForm.organizationIds = Object.keys(this.selectedOrgs).filter(
      (id) => this.selectedOrgs[id]
    );
    this.allOrgSelected =
      this.getNumberOfSelectedOrgs() === this.organizations.length;
  }

  showNewRuleForm(): void {
    this.formMode = 'new';
    this.showCreateRuleForm = true;
    this.showRuleForm = true;
  
    this.resetRuleForm();
    this.selectedOrgs = {};
    this.allOrgSelected = false;
    this.orgSelected();
  }


  editRule(rule: GeofenceRule): void {
    this.formMode = 'edit';
    this.selectedRule = rule;
    this.showRuleForm = true;
    this.showCreateRuleForm = true;
    this.ruleForm = {
      ...rule,
      daysOfWeek: this.normalizeDaysOfWeek((rule as any).daysOfWeek)
    };
  }

  private normalizeDaysOfWeek(daysOfWeek: any): Record<DayOfWeek, boolean> {
    const defaultDays: Record<DayOfWeek, boolean> = {
      sun: false, mon: false, tue: false, wed: false, thu: false, fri: false, sat: false
    };
    if (!daysOfWeek || typeof daysOfWeek !== 'object') return defaultDays;
    if (Array.isArray(daysOfWeek)) {
      daysOfWeek.forEach((idx: number) => {
        const key = this.daysOfWeek[idx];
        if (key) defaultDays[key] = true;
      });
      return defaultDays;
    }
    const normalized: Record<DayOfWeek, boolean> = { ...defaultDays };
    for (const day of this.daysOfWeek) {
      normalized[day] = !!daysOfWeek[day];
    }
    return normalized;
  }
  deleteRule(id: string): void {}
  private resetRuleForm(): void {
    this.ruleForm = {
      name: '',
      ingress: false,
      egress: false,
      daysOfWeek: {
        sun: false,
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false
      } as Record<DayOfWeek, boolean>,
      startTime: '',
      endTime: '',
      organizationIds: [],
      userIds: [],
      geofenceIds: [],
      perimeterIds: [],
      active: false,
      openSelectOrganizations: false,
      openSelectUsers: false,
      openSelectGeofences: false,
      openSelectPerimeters: false
    };
  }

  showGeometry(geo: any): void {
    this.viewer = this.coresService.getViewer();
    const geojson = { type: 'Feature', geometry: geo.geometry };
    this.viewer.dataSources.add(
      Cesium.GeoJsonDataSource.load(geojson, {
        stroke: Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#ffff00'), 1.0),
        fill: Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#ffff00'), 0.5),
      })
    ).then((data: any) => {
      this.geofenceDataSource[geo.id] = data;
      this.geofenceDataSource[geo.id].show = true;
      if (this.camera?.flyToEntity) {
        this.camera.flyToEntity(this.geofenceDataSource[geo.id]);
      }
    });
  }

  // Check if geometry is showing
  showingGeometry(geo: any): boolean {
    return !!this.geofenceDataSource[geo.id];
  }

  removeGeometry(geo: any): void {
    if (this.geofenceDataSource[geo.id]) {
      this.viewer.dataSources.remove(this.geofenceDataSource[geo.id]);
      delete this.geofenceDataSource[geo.id];
    }
  }

  removeAllGeometry(): void {
    Object.values(this.geofenceDataSource).forEach((geo: any) => {
      this.viewer.dataSources.remove(geo);
    });
    this.geofenceDataSource = {};
  }

  showHideGeometry(geo: any): void {
    if (this.geofenceDataSource[geo.id]) {
      this.removeGeometry(geo);
    } else {
      this.showGeometry(geo);
    }
  }

  private padZero(a: number | string): string {
    return parseInt(a as string, 10) < 10 ? '0' + a : a.toString();
  }

  submitNewRule(): void {
    const label = this.ruleForm.name;
    const isActive = this.ruleForm.active;
    const ingress = this.ruleForm.ingress;
    const egress = this.ruleForm.egress;
    const startTime = this.ruleForm.startTime;
    const endTime = this.ruleForm.endTime;
    const selectedGeofences = this.ruleForm.geofenceIds;
    const selectedPerimeters = this.ruleForm.perimeterIds;
    const userIds = this.ruleForm.userIds;
    const orgIds = this.ruleForm.organizationIds;

    const days = this.daysOfWeek
      .map((day, idx) => (this.ruleForm.daysOfWeek[day] ? idx : null))
      .filter((v) => v !== null);

    let errorMsg = '';
    if (!label) errorMsg += 'Missing Name<br>';
    if (!ingress && !egress) errorMsg += 'Missing both Ingress and Egress<br>';
    if (days.length === 0) errorMsg += 'Missing Day of Week<br>';
    if (!startTime) errorMsg += 'Missing Start Time<br>';
    if (!endTime) errorMsg += 'Missing End Time<br>';
    if (orgIds.length + userIds.length === 0) errorMsg += 'Missing Organizations / Users<br>';
    if ((selectedGeofences.length + selectedPerimeters.length) === 0) errorMsg += 'Missing Geofences / Perimeters';

    if (errorMsg) {
      this.showAlert('Error:\n' + errorMsg.replace(/<br>/g, '\n'));
      return;
    }

    const perimeterIds = [...selectedPerimeters, ...selectedGeofences];
    const start = startTime + ':00';
    const end = endTime + ':00';

    this.getOrCreateIntegration().then((integrationId) => {
      return this.createRule(
        integrationId,
        label,
        isActive,
        perimeterIds,
        ingress,
        egress,
        start,
        end,
        days,
        userIds,
        orgIds
      );
    }).then((results: any) => {
      if (this.formMode === 'edit') return;
      const ruleId = Array.isArray(results) ? results[0]?.id : results?.id;
      return this.createAction(ruleId);
    }).then(() => {
      this.showAlert('Success');
      this.showCreateRuleForm = false;
      this.loadRules();
    }).catch((error: { error: { message: any; }; message: any; }) => {
      this.showAlert('There was an error. msg: ' + (error?.error?.message || error.message));
      console.error(error);
    });
  }

  getOrCreateIntegration(): Promise<string> {
    const orgId = this.getCustomerOrgId();
    const url = `${this.integrationPulseUrl}/integration/find`;
    const where = {
      where: {
        integrationType: 'SYSTEM_EVENT',
        organizationId: orgId
      }
    };
    return this.api.post<any[]>(url, where).toPromise().then(results => {
      if (results && results.length > 0) {
        return results[0].id;
      }
      // else, create integration
      const integration = {
        organizationId: orgId,
        integrationType: 'SYSTEM_EVENT',
        name: 'System-Event-Worker',
        dataSpec: { name: 'string', organizationIds: 'array', payload: 'json' },
        config: { config: 'tbd' },
        worker: null,
        transformExpression: {
          expressionType: 'ObjectExpression',
          template: {
            organizationId: { expressionType: 'PropertyExpression', property: 'integration.organizationId' }
          }
        }
      };
      return this.api.post<any>(url + '/integration', integration).toPromise().then(newObj => newObj.id);
    });
  }
  getCustomerOrgId(): any {
    const myFirstOrg = this.orgUtil?.data?.myFirstOrg;
    let organizationId = myFirstOrg?.arcAngelId || myFirstOrg?.id;

    if ([1, 2, 7].includes(Number(organizationId))) {
      organizationId = 3;
    }
    return organizationId;
  }
  createRule(
    integrationId: string,
    label: string,
    isActive: boolean,
    perimeterIds: string[],
    ingress: boolean,
    egress: boolean,
    start: string,
    end: string,
    days: number[],
    userIds: string[],
    orgIds: string[]
  ): Promise<any> {
    const url = `${this.integrationPulseUrl}/rule/find`;
    const param: any = {
      integrationId,
      name: label,
      ruleType: 'PERIMETER_ENTER_EXIT',
      active: isActive,
      expression: {
        expressionType: 'FunctionExpression',
        errorLevel: 'Warn',
        functionSpec: {
          className: 'SysEventLib',
          method: 'didDeviceEnterExitPerimeters',
          argNames: [
            'event', 'integration', 'perimeterIds', 'onEnter', 'onExit', 'start', 'end', 'days', 'userIds', 'orgIds'
          ]
        },
        argsExpression: {
          expressionType: 'ObjectExpression',
          template: {
            event: { expressionType: 'PropertyExpression', property: 'event' },
            integration: { expressionType: 'PropertyExpression', property: 'integration' },
            perimeterIds: { expressionType: 'ValueExpression', value: perimeterIds },
            onEnter: { expressionType: 'ValueExpression', value: ingress },
            onExit: { expressionType: 'ValueExpression', value: egress },
            start: { expressionType: 'ValueExpression', value: start },
            end: { expressionType: 'ValueExpression', value: end },
            days: { expressionType: 'ValueExpression', value: days },
            userIds: { expressionType: 'ValueExpression', value: userIds },
            orgIds: { expressionType: 'ValueExpression', value: orgIds }
          }
        }
      }
    };

    if (this.formMode === 'edit' && this.selectedRule) {
      param.id = this.selectedRule.id;
      param.integrationId = this.selectedRule.integrationId;
    }

    const method = this.formMode === 'new' ? 'post' : 'patch';
    const apiUrl = this.formMode === 'new'
      ? `${this.integrationPulseUrl}/rule/find`
      : `${this.integrationPulseUrl}/rule/${param.id}`;

    return this.api[method]<any>(apiUrl, param).toPromise();
  }

  createAction(ruleId: string): Promise<any> {
  const param = {
    name: 'Perimeter Alert',
    ruleId: ruleId,
    functionExpression: {
      expressionType: 'FunctionExpression',
      errorLevel: 'Warn',
      functionSpec: {
        className: 'AlertLib',
        method: 'createAlert',
        argNames: [
          'event',
          'integration',
          'incidentCategoryName',
          'name',
          'description',
          'features'
        ]
      },
      argsExpression: {
        expressionType: 'ObjectExpression',
        template: {
          event: {
            expressionType: 'PropertyExpression',
            property: 'event'
          },
          integration: {
            expressionType: 'PropertyExpression',
            property: 'integration'
          },
          incidentCategoryName: {
            expressionType: 'ValueExpression',
            value: 'Perimeter Alert'
          },
          name: {
            expressionType: 'StringExpression',
            templateString: 'Perimeter Alert - {{enterExit}} - {{userName}}',
            replacements: {
              expressionType: 'ObjectExpression',
              template: {
                enterExit: {
                  expressionType: 'PropertyExpression',
                  property: 'event.platformData.direction'
                },
                userName: {
                  expressionType: 'PropertyExpression',
                  property: 'event.platformData.user.name'
                }
              }
            }
          },
          description: {
            expressionType: 'StringExpression',
            templateString: 'Perimeter Alert - {{enterExit}} - {{userName}}',
            replacements: {
              expressionType: 'ObjectExpression',
              template: {
                enterExit: {
                  expressionType: 'PropertyExpression',
                  property: 'event.platformData.direction'
                },
                userName: {
                  expressionType: 'PropertyExpression',
                  property: 'event.platformData.user.name'
                }
              }
            }
          },
          features: {
            expressionType: 'PropertyExpression',
            property: 'event.platformData.features'
          }
        }
      }
    }
  };

  const url = `${this.integrationPulseUrl}/action`;

  return this.api.post<any>(url, param).toPromise();
}

  userSearchTextChanged(): void {
    this.filteredUsers = this.filterUsers(this.userSearchText);
  }

  filterUsers(text: string): any[] {
    if (!text || text.length < 2) return [];
    text = text.toLowerCase();
    const users1 = this.allUsers.filter(user =>
      user.name.toLowerCase().startsWith(text)
    );
    const users2 = this.allUsers.filter(user =>
      !user.name.toLowerCase().startsWith(text) && user.name.toLowerCase().includes(text)
    );
    const users = [...users1, ...users2].filter(
      user => !this.selectedUsers.some(u => u.id === user.id)
    );
    return users;
  }

  selectUser(user: any): void {
    this.selectedUsers.push(user);
    this.ruleForm.userIds = this.selectedUsers.map(u => u.id);
    this.userSearchTextChanged();
  }

  removeSelectedUser(user: any): void {
    this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id);
    this.ruleForm.userIds = this.selectedUsers.map(u => u.id);
    this.userSearchTextChanged();
  }

  syncSelectedUsersFromIds(): void {
    this.selectedUsers = this.allUsers.filter(u => this.ruleForm.userIds.includes(u.id));
  }

  geofenceSearchTextChanged(): void {
    this.filteredSelectableGeofences = this.filterGeofences(this.geofenceSearchText);
  }

  filterGeofences(text: string): Geofence[] {
    let geos = this.geofences.filter(
      geo => !this.selectedGeofences.some(sel => sel.id === geo.id)
    );
    if (!text) return geos;
    text = text.toLowerCase();
    const geos1 = geos.filter(geo => geo.label.toLowerCase().startsWith(text));
    const geos2 = geos.filter(
      geo => !geo.label.toLowerCase().startsWith(text) && geo.label.toLowerCase().includes(text)
    );
    return [...geos1, ...geos2];
  }

  selectGeofence(geo: Geofence): void {
    this.selectedGeofences.push(geo);
    this.ruleForm.geofenceIds = this.selectedGeofences.map(g => g.id);
    this.geofenceSearchTextChanged();
  }

  removeSelectedGeofence(geo: Geofence): void {
    this.selectedGeofences = this.selectedGeofences.filter(g => g.id !== geo.id);
    this.ruleForm.geofenceIds = this.selectedGeofences.map(g => g.id);
    this.geofenceSearchTextChanged();
  }

  syncSelectedGeofencesFromIds(): void {
    this.selectedGeofences = this.geofences.filter(g => this.ruleForm.geofenceIds.includes(g.id));
  }

  buildingChanged(): void {
    this.floors = this.selectedBuilding?.floorPerimeters || [];
    this.selectedFloor = null;
    this.rooms = [];
    this.selectedRoom = null;
    this.getFilteredPerimeter();
  }

  floorChanged(): void {
    let perimeters: any[] = [];
    if (this.selectedFloor?.perimeters) {
      if (Array.isArray(this.selectedFloor.perimeters)) {
        perimeters = this.selectedFloor.perimeters;
      } else if (typeof this.selectedFloor.perimeters === 'object') {
        perimeters = Object.values(this.selectedFloor.perimeters);
      }
    }
    this.rooms = perimeters.filter((o: any) => o.perimeterType === 'ROOM');
    this.selectedRoom = null;
    this.getFilteredPerimeter();
  }

  roomChanged(): void {
    this.getFilteredPerimeter();
  }

  getFilteredPerimeter(): void {
    if (this.selectedBuilding && this.selectedFloor && this.selectedRoom) {
      this.filteredPerimeter = {
        id: this.selectedRoom.arcAngelId,
        name: this.selectedRoom.name,
        display: `${this.selectedBuilding.name} > ${this.selectedFloor.name} > ${this.selectedRoom.name}`
      };
    } else if (this.selectedBuilding && this.selectedFloor) {
      this.filteredPerimeter = {
        id: this.selectedFloor.perimeterId,
        name: this.selectedFloor.name,
        display: `${this.selectedBuilding.name} > ${this.selectedFloor.name}`
      };
    } else if (this.selectedBuilding) {
      this.filteredPerimeter = {
        id: this.selectedBuilding.perimeterId,
        name: this.selectedBuilding.name,
        display: this.selectedBuilding.name
      };
    } else {
      this.filteredPerimeter = null;
    }
  }

  selectFilteredPerimeter(): void {
    if (this.filteredPerimeter && !this.isPerimeterSelected(this.filteredPerimeter.id)) {
      this.selectedPerimeters.push(this.filteredPerimeter);
      this.ruleForm.perimeterIds = this.selectedPerimeters.map(p => p.id);
    }
  }

  isPerimeterSelected(id: string): boolean {
    return this.selectedPerimeters.some(p => p.id === id);
  }

  removeSelectedPerimeter(perimeter: any): void {
    this.selectedPerimeters = this.selectedPerimeters.filter(p => p.id !== perimeter.id);
    this.ruleForm.perimeterIds = this.selectedPerimeters.map(p => p.id);
  }
  startDrawing(): void {
    this.openGeofenceCreator.emit();
  }
 
 

  saveNewGeofence(): void {
    if (!this.newGeofenceLabel || !this.drawnPolygon || this.drawnPolygon.length < 3) {
      this.showAlert('Please provide a name and draw a valid polygon.');
      return;
    }

    const coords = this.drawnPolygon.map(coord => [coord[0], coord[1]]);
    if (
      coords.length < 3 ||
      coords[0][0] !== coords[coords.length - 1][0] ||
      coords[0][1] !== coords[coords.length - 1][1]
    ) {
      coords.push(coords[0]);
    }

    const newGeofence: Partial<Geofence> = {
      label: this.newGeofenceLabel,
      type: 'GEOFENCE',
      geometry: {
        type: 'Polygon',
        coordinates: [coords]
      },
      organizationIds: [this.getCustomerOrgId()]
    };

    this.geofenceService.createGeofence(newGeofence).subscribe({
      next: () => {
        this.newGeofenceLabel = '';
        this.drawnPolygon = null;
        this.illumPolygonCreator.clearDrawing();
        this.loadGeofences();
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  cancelNewGeofence(): void {
    this.newGeofenceLabel = '';
    this.drawnPolygon = null;
    this.illumPolygonCreator.clearDrawing();
  }

  private showAlert(message: string) {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top'
    });
      modalRef.componentInstance.message = message;
      modalRef.componentInstance.showCancel = false;
      return modalRef.result;
    }
}